<form name="moda-recovery-password-form" class="modal-recovery-password login-modal">
    <div class="login-header">
        <h3 class="modal-title login-title" id="modal-title">{{ 'MODAL_RECOVERY_PASSWORD.TITLE' | translate }}</h3>
        <img class="pointer" width="24" height="24" alt="{{ 'COMMON.CLOSE' | translate }}" src="assets/img/close.svg" (click)="cancel()">
    </div>
    <div class="modal-body" id="modal-body" *ngIf="alertMessage !== 'MODAL_RECOVERY_PASSWORD.OK_MESSAGE'">
        <div class="">
            <div class="">
                <input type="text" required name="username" autocomplete="email" [(ngModel)]="username"
                                                            id="username" class="form-control" title="{{ 'MODAL_RECOVERY_PASSWORD.USERNAME' | translate }}"
                                                                                               placeholder="{{ 'MODAL_RECOVERY_PASSWORD.USERNAME' | translate }}">
            </div>
            <div class="errorMessage" *ngIf="alertMessage">
                {{ alertMessage | translate }}
            </div>
        </div>
    </div>
    <div class="modal-body" id="modal-body" *ngIf="alertMessage === 'MODAL_RECOVERY_PASSWORD.OK_MESSAGE'">
      <div class="okMessage">
        <p>{{ alertMessage | translate }}</p>
      </div>
    </div>
    <div class="login-footer text-center" *ngIf="alertMessage !== 'MODAL_RECOVERY_PASSWORD.OK_MESSAGE'">
        <button class="btn btn--light" type="button" (click)="cancel()">{{ 'MODAL_RECOVERY_PASSWORD.CANCEL' | translate }}</button>
        <button class="btn appColorBackground white" [style.backgroundColor]="eventData['mainColor']" [style.color]="eventData['languageColor']" type="button" (click)="recoveryPasswordBtn()">{{ 'MODAL_RECOVERY_PASSWORD.SEND' | translate }}</button>
    </div>
    <div class="login-footer d-flex justify-content-end" *ngIf="alertMessage === 'MODAL_RECOVERY_PASSWORD.OK_MESSAGE'">
        <button class="btn btn--secondary" type="button" (click)="cancel()">{{ 'MODAL_RECOVERY_PASSWORD.CANCEL' | translate }}</button>
    </div>
</form>
